import { MaybeRefOrGetter, toValue, watch } from 'vue';
import { trackHomeEvent } from '@/api/tracking';
import { HomeTrackingEventMap } from '@/types/home';
import { useIntersectionOnce } from '@/utils/composables/useIntersectionOnce';

type HomeSectionViewEventName = Exclude<
  keyof HomeTrackingEventMap,
  'next_layout_switch' | 'legacy_layout_switch'
>;

// トップ画面の各セクションが表示されたときに一度だけ view イベントを送るための共通ロジック。
// setRef を要素に渡すと、その要素がビューポートに入り、かつ isReady が true になった時点で発火する。
export const useHomeSectionViewTracking = <K extends HomeSectionViewEventName>(
  name: K,
  isReady: MaybeRefOrGetter<boolean>,
  data: () => Omit<HomeTrackingEventMap[K], 'request_id'>,
) => {
  const requestId = crypto.randomUUID();
  const { isVisible, setRef } = useIntersectionOnce();

  let tracked = false;
  watch([isVisible, () => toValue(isReady)], ([visible, ready]) => {
    if (!visible || !ready || tracked) return;
    tracked = true;
    trackHomeEvent(name, {
      ...data(),
      request_id: requestId,
    } as HomeTrackingEventMap[K]);
  });

  return { requestId, setRef };
};
